module.exports = __webpack_public_path__ + "static/media/corporate-services-img91.a6ad9af8.jpg";